import { useReframe } from 'nike-re-framejs';
import { scoreboardType$$ } from '../push/overview/subs';

export const useScoreboardType = scoreboardTypeId => {
    const derefSub = useReframe();
    const scoreboardType = derefSub(scoreboardType$$(scoreboardTypeId));
    return scoreboardType
        ? {
              showTimer: scoreboardType.get('showTimer'),
              timerFormat: scoreboardType.get('timerFormat'),
              showRedCards: scoreboardType.get('showRedCards'),
              showYellowCards: scoreboardType.get('showYellowCards'),
              showCorners: scoreboardType.get('showCorners')
          }
        : {};
};
